const TSL_RECENTLY_VIEWED_KEY = 'tsl:recently-viewed';
const TSL_RECENTLY_VIEWED_MAX = 12;

class TslRecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.grid = this.querySelector('[data-recently-viewed-grid]');
    this.cardSectionId = this.dataset.cardSectionId || 'tsl-recently-viewed-card';
    this.limit = parseInt(this.dataset.limit, 10) || 8;
    this.excludeProductId = this.dataset.excludeProductId || '';
    this.renderSource = this.dataset.renderSource || 'card';
    this.sectionId = this.dataset.sectionId || '';
  }

  isDesignMode() {
    return Boolean(
      window.Shopify?.designMode ||
        document.documentElement.classList.contains('shopify-design-mode') ||
        document.body?.classList.contains('shopify-design-mode')
    );
  }

  connectedCallback() {
    if (!this.grid) return;

    if (this.isDesignMode()) {
      this.classList.remove('hidden');
      this.grid.querySelectorAll('[data-recently-viewed-card]').forEach((card) => {
        card.hidden = false;
      });
      return;
    }

    const handles = this.getStoredHandles();
    if (!handles.length) {
      this.classList.add('hidden');
      return;
    }

    this.render(handles);
  }

  getStoredHandles() {
    try {
      const items = JSON.parse(localStorage.getItem(TSL_RECENTLY_VIEWED_KEY) || '[]');
      return items
        .filter((item) => item && item.handle && String(item.id) !== String(this.excludeProductId))
        .slice(0, this.limit)
        .map((item) => item.handle);
    } catch (error) {
      return [];
    }
  }

  extractCard(html) {
    if (!html) return '';
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const card = doc.querySelector('[data-recently-viewed-card]');
    if (!card) return '';
    card.hidden = false;
    if (!card.classList.contains('grid__item')) {
      card.classList.add('grid__item');
    }
    return card.outerHTML;
  }

  async render(handles) {
    const root = window.Shopify?.routes?.root || '/';
    const useSectionId = this.renderSource === 'section' && this.sectionId;

    const requests = handles.map((handle) => {
      const url = useSectionId
        ? `${root}products/${handle}?section_id=${encodeURIComponent(this.sectionId)}`
        : `${root}products/${handle}?sections=${encodeURIComponent(this.cardSectionId)}`;

      return fetch(url)
        .then((response) => (useSectionId ? response.text() : response.json()))
        .then((payload) => {
          if (useSectionId) return this.extractCard(payload);
          const sectionHtml = payload?.[this.cardSectionId] || '';
          return this.extractCard(sectionHtml);
        })
        .catch(() => '');
    });

    const htmlParts = (await Promise.all(requests)).filter(Boolean);
    if (!htmlParts.length) {
      this.classList.add('hidden');
      return;
    }

    this.grid.innerHTML = htmlParts.join('');
    this.classList.remove('hidden');
  }
}

if (!customElements.get('tsl-recently-viewed-products')) {
  customElements.define('tsl-recently-viewed-products', TslRecentlyViewedProducts);
}

if (!window.TslRecentlyViewed) {
  window.TslRecentlyViewed = {
    track(product) {
      if (!product?.id || !product?.handle) return;

      try {
        const items = JSON.parse(localStorage.getItem(TSL_RECENTLY_VIEWED_KEY) || '[]').filter(
          (item) => item && String(item.id) !== String(product.id)
        );
        items.unshift({ id: product.id, handle: product.handle });
        localStorage.setItem(TSL_RECENTLY_VIEWED_KEY, JSON.stringify(items.slice(0, TSL_RECENTLY_VIEWED_MAX)));
      } catch (error) {
        /* ignore storage errors */
      }
    },
  };
}
